import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

const FadeInOnScroll = ({
  children,
  animation = 'fade-up',
  duration = 800,
  delay = 0,
  easing = 'ease-in-out',
  once = true,
  className = '',
  style = {},
  ...props 
}) => {
  useEffect(() => {
    AOS.init({ duration, easing, once });
  }, []);

  return (
    <div
      data-aos={animation}
      data-aos-delay={delay}
      data-aos-duration={duration}
      data-aos-easing={easing}
      data-aos-once={once}
      className={className}
      style={style}
      {...props}
    >
      {children}
    </div>
  );
};

export default FadeInOnScroll;
